<template>
  <Page>
    <div class="container container--small">
      <div
        v-if="route.params?.city"
        class="h-margin-bottom">
        <NuxtLink :to="{ name: $lang + '-vacancies' }">
          {{ $t('static/our-vacancies') }}
        </NuxtLink>
        <template v-if="route.params?.city">
          &nbsp;/ {{ results?.[0].location }}
        </template>
      </div>
      <h1 v-if="results">
        {{ $t('static/our-vacancies') }}

        <template v-if="route.params?.city">
          in {{ results[0].location }}
        </template>
      </h1>
      <div
        class="h-margin-bottom h-margin-top"
        v-html="$t('static/vacancies-openingtext')" />
      <h4
        :class="$style['page__subtitle']"
        class="base-font h5 h-margin-top-xl">
        {{ $t('static/our-vacancies') }}
      </h4>
      <ul class="container__content striped h-margin-bottom-l">
        <li
          v-for="job in results"
          :key="job.id">
          <NuxtLink
            :to="{
              name: $lang + '-vacancies-city-title-vacancy',
              params: { city: route.params.city, title: job.slug ,vacancy: job.id}
            }">
            {{ job.title }}
          </NuxtLink>
        </li>
      </ul>
      <b v-if="!results">{{ $t('static/no-vacancies') }}</b>
      <ServiceBanner class="h-margin-top-xl" />
    </div>
  </Page>
</template>
<script setup>
import {
  formatCanonical,
  formatOpenGraph,
  formatMetaDescription
} from '~/helpers/metadata'

const route = useRoute()
const { $lang, $api } = useNuxtApp()
await useI18n(['vacancies', 'static'])

const { data, error } = await useAsyncData(
  route.params.city,
  async () => {
    const [results, navigation] = await Promise.all([
      $api(`jobs/${route.params.city}?encoded_url=${encodeURIComponent(route.path)}`),
      $api('navigation/8')
    ])
    return { results, navigation }
  })

if (error.value) {
  await navigateTo({ name: `${$lang}-vacancies` })
}

const results = computed(() => data.value.results)
const navigation = computed(() => data.value.navigation)

const metaData = { ...unref(navigation.value).metaData }

useHead({
  title: metaData.pageTitle,
  titleTemplate: '%s',
  link: [...formatCanonical(metaData)],
  meta: [
    ...formatOpenGraph(metaData.openGraph),
    formatMetaDescription(metaData)
  ],
  script: [{ type: 'application/ld+json', innerHTML: metaData.schemaOrg }] // Structured data
})

</script>
<style lang="scss" module>
.page {
  &__image {
    display: flex;
    max-height: 60vh;

    img {
      object-position: 50% 1%;
      object-fit: cover;
      width: 100%;
    }
  }

  a {
    text-decoration: underline;
  }

  &__subtitle {
    font-size: $font-size-l;

    a {
      text-decoration: none;
    }
  }
}
</style>
